import React from 'react';
import styled from 'styled-components';
import colors from '../ui/colors';

const Legend = styled(({text, ...rest}) => {
  return (
    <div {...rest}>
      <span>{text}</span>
    </div>
  )
})`
  font-size: 0.875rem;
  color: ${colors.BRAND_GREEN}
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

export default Legend;



// WEBPACK FOOTER //
// ./src/modules/common/components/legend/Legend.js